import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold">Accès refusé</h1>
        <p className="mt-2 text-sm text-gray-600">
          Vous êtes authentifié, mais vous n&apos;avez pas le rôle requis pour
          accéder à cette page.
        </p>
        <div className="mt-6 flex gap-3">
          <Button onClick={() => navigate("/", { replace: true })}>
            Retour à l&apos;accueil
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
          >
            Revenir en arrière
          </Button>
        </div>
      </div>
    </div>
  );
}

